import type { SVGProps } from 'react';

const ReactComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 392.54 392.48"
    {...props}
  >
    <path
      d="M268.38 143.79C337.71 138.66 392.54 80.62 392.54 10V0H258.38c-3.36 0-6.7.12-10 .37-43.99 3.25-82.15 27.82-104.16 63.38V0h-10C63.6 0 5.56 54.83.43 124.16c-.27 3.1-.43 6.47-.43 10.08 0 3.55.16 6.87.43 9.92.9 11.92 4.26 35.54 19.57 60.32a135.24 135.24 0 0 0 43.81 43.84H.06v144.16h10c48.17 0 90.5-25.52 114.16-63.75v63.75h10c56 0 104.09-34.48 124.16-83.33 20.07 48.85 68.16 83.33 124.16 83.33h10V124.16h-10c-56 0-104.09 34.48-124.16 83.33-10.82-26.34-29.79-48.5-53.75-63.33h53.75c3.36 0 6.7-.12 10-.37m0-123.79h103.73c-4.8 54.99-48.74 98.93-103.73 103.73zM20.06 372.05V268.32h103.73c-4.8 54.99-48.74 98.93-103.73 103.73m104.16-124.16c-54.99-4.8-98.93-48.74-103.73-103.73h103.73zm0-123.73H20.49c4.8-54.99 48.74-98.93 103.73-103.73zm248.32 20.43v103.73H268.81c4.8-54.99 48.74-98.93 103.73-103.73m0 123.73v103.73c-54.99-4.8-98.93-48.74-103.73-103.73zM144.22 372.05V268.32h103.73c-4.8 54.99-48.74 98.93-103.73 103.73m103.73-123.73H144.22V144.59c54.99 4.8 98.93 48.74 103.73 103.73m.43-124.16H144.65c4.8-54.99 48.74-98.93 103.73-103.73z"
      style={{
        fill: 'var(--color-brand-main)',
      }}
    />
  </svg>
);
export { ReactComponent };
